import { httpUtil } from './httpUtil';

const querystring = require('querystring');

let pluginsUrl = document._portalConfig.urlPlugins;
let api_key = document._portalConfig.apiKeyPlugins;

let urlMWPaygate = document._portalConfig.urlMWPaygate;
let apiKeyMWPaygate = document._portalConfig.apiKeyMWPaygate;

export const airlinkservices = {
    getCustomers,
    initiatePayment,
    createPayment,
    getCustomfield,
    updateCustomfield,
    initiateTopup,
    createTopup,
}

async function getCustomers(email_address, domain) {
    try {
        const response = await get({
            resourcePath: '/customers',
            queryParams: {
                email_address: email_address,
                domain: domain,
            }
        })
        return response;
    } catch (ex) {
        console.log("getCustomers exception===", ex);
        return ex;
    }
}

async function getCustomfield(domain, entity) {
    try {
        const response = await get({
            resourcePath: '/custom_fields',
            queryParams: {
                domain: domain,
                entity: entity
            }
        })
        return response;
    } catch (ex) {
        console.log("getCustomfield exception===", ex);
        return ex;
    }
}

async function updateCustomfield({
    domain,
    type,
    order,
} = {}) {
    try {
        let contactId = httpUtil.getSession().sub;
        const response = await put({
            resourcePath: '/contacts/'+ contactId,
            queryParams: {
                domain: domain,
            },
            body: {
                "custom_fields": [
                    {
                        "key": "preferred_communication_method",
                        "value": type,
                        order: Number(order),
                    }
                ]
            },
            
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function initiatePayment({
    is_recurring,
    amount,
    organisation = 'airlink',
} = {}) {
    try {
        let id = httpUtil.getSession().sub;
        const response = await post({
            resourcePath: '/payment_gateways/init_payment',
            body: {
                contact_id: id,
                amount: amount,
                is_recurring: is_recurring,
                organisation: organisation,
            },
            isPaygate: true,
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function createPayment({
    amount,
    transaction_id,
    status,
    organisation = 'airlink',
    type_name,
} = {}) {
    try {
        let id = httpUtil.getSession().sub;
        const response = await post({
            resourcePath: '/payment_gateways/create_payment',
            body: {
                contact_id: id,
                amount: amount,
                status: status,
                transaction_id: transaction_id,
                organisation: organisation,
                type_name: type_name,
            },
            isPaygate: true,
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function initiateTopup({
    is_recurring,
    amount,
    organisation = 'airlink',
    wallet_id,
} = {}) {
    try {
        let id = httpUtil.getSession().sub;
        const response = await post({
            resourcePath: '/payment_gateways/init_topup',
            body: {
                contact_id: id,
                wallet_id,
                amount: amount,
                is_recurring: is_recurring,
                organisation: organisation,
            },
            isPaygate: true,
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function createTopup({
    amount,
    wallet_id,
    payment_method,
    organisation = 'airlink',
    transaction_id,
    status,
} = {}) {
    try {
        const response = await post({
            resourcePath: '/payment_gateways/create_topup',
            body: {
                wallet_id,
                payment_method,
                amount: amount,
                organisation: organisation,
                transaction_id,
                status,
            },
            isPaygate: true,
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

function createOption(isPaygate) {
    var options = {};
    options.headers = {
        'User-Agent': 'request',
        'Content-Type': 'application/json; charset=utf-8',
        'api_key': isPaygate ? apiKeyMWPaygate : api_key
    };
    return options;
}

function cleanObj(obj) {
    for (var propName in obj) {
        if (obj[propName] === null || obj[propName] === undefined) {
            delete obj[propName];
        }
    }
    return obj;
}

function json2Obj(str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        return null;
    }
}

function getURI(resourcePath, isPaygate) {
    if(isPaygate) return urlMWPaygate + resourcePath;
    return pluginsUrl + resourcePath;
}

async function get({
    resourcePath,
    queryParams
}) {
    try {
        var options = createOption();
        options.method = 'GET';
        let uri = getURI(resourcePath);
        if (queryParams)
            uri = uri + '?' + querystring.encode(cleanObj(queryParams));;
        console.log("GET uri:", uri);
        console.log("GET options:", options);
        var response = await fetch(uri, options);
        let bodyText = await response.text()
        console.log('Response - ', response.status, ' - Body:', json2Obj(bodyText));
        if (response.status == '200') {
            return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
        } else {
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        }
    } catch (e) {
        console.log("AAAA e:", e);
        let bodyText = await e.text();
        return { code: e.status, bodyText: bodyText, error: json2Obj(bodyText) };
    }
}

async function post({
    resourcePath,
    body,
    isPaygate = false,
}) {
    try {
        var options = createOption(isPaygate);
        options.method = 'POST';
        let uri = getURI(resourcePath, isPaygate);
        if (body)
            options.body = JSON.stringify(body);
        console.log("GET uri:", uri);
        console.log("options:", options);
        var response = await fetch(uri, options);
        let bodyText = await response.text()
        console.log('Response - ', response.status, ' - Body:', json2Obj(bodyText));
        if (response.status == '200') {
            return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
        } else {
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        }
    } catch (e) {
        console.log("post exception:", e);
        let bodyText = await e.text();
        return { code: e.status, bodyText: bodyText, error: json2Obj(bodyText) };
    }
}

async function put({
    resourcePath,
    body,
    queryParams,
}) {
    try {
        var options = createOption();
        options.method = 'PUT';
        let uri = getURI(resourcePath);
        if (queryParams)
            uri = uri + '?' + querystring.encode(cleanObj(queryParams));;
        if (body)
            options.body = JSON.stringify(body);
        console.log("GET uri:", uri);
        console.log("options:", options);
        var response = await fetch(uri, options);
        let bodyText = await response.text()
        console.log('Response - ', response.status, ' - Body:', json2Obj(bodyText));
        if (response.status == '200') {
            return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
        } else {
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        }
    } catch (e) {
        console.log("put exception:", e);
        let bodyText = await e.text();
        return { code: e.status, bodyText: bodyText, error: json2Obj(bodyText) };
    }
}

